 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import {Lock, MailOutline} from '@mui/icons-material'
import React, {useState} from 'react'
import {useRouteMatch} from 'react-router'

import useAtmosphere from '../hooks/useAtmosphere'
import useMutationProps from '../hooks/useMutationProps'
import PushInvitationMutation from '../mutations/PushInvitationMutation'
import SendClientSideEvent from '../utils/SendClientSideEvent'
import PrimaryButton from './PrimaryButton'

const RequestToJoinComponent = () => {
  const atmosphere = useAtmosphere()
  const match = useRouteMatch('/team/:teamId')
  const teamId = _optionalChain([match, 'optionalAccess', _ => _.params, 'access', _2 => _2.teamId])
  const [isRequestSent, setIsRequestSent] = useState(false)
  const {onError, onCompleted, error} = useMutationProps()

  const handleRequestJoin = () => {
    if (!teamId) return
    SendClientSideEvent(atmosphere, 'Sent request to join from public teams', {teamId})
    PushInvitationMutation(
      atmosphere,
      {teamId},
      {
        onError,
        onCompleted: (res) => {
          if (_optionalChain([res, 'access', _3 => _3.pushInvitation, 'optionalAccess', _4 => _4.error])) {
            const error = new Error(_optionalChain([res, 'access', _5 => _5.pushInvitation, 'optionalAccess', _6 => _6.error, 'optionalAccess', _7 => _7.message]))
            onError(error)
          } else {
            setIsRequestSent(true)
            onCompleted()
          }
        }
      }
    )
  }

  return (
    React.createElement('div', { className: "relative z-10 flex h-full w-full flex-col items-center justify-center overflow-y-auto"        ,}
      , React.createElement('div', { className: "mb-20 flex max-h-[90vh] w-[50%] min-w-[280px] max-w-[calc(100vw-48px)] flex-col items-center rounded bg-white p-8 shadow-2xl"           ,}
        , isRequestSent ? (
          React.createElement(MailOutline, { className: "text-purple-500 h-10 w-10 rounded-full"   ,} )
        ) : (
          React.createElement(Lock, { className: "text-purple-500 h-10 w-10 rounded-full"   ,} )
        )
        , React.createElement('div', { className: "text-gray-700 my-4 flex flex-col items-center justify-between text-sm font-semibold leading-5"        ,}
          , isRequestSent ? 'Request Sent' : 'Request to Join'
        )
        , React.createElement('div', { className: "my-2 mb-7 px-16 text-center text-sm leading-5"     ,}
          , isRequestSent
            ? 'Your request to join the team has been sent.'
            : "You're not a member of this team yet. Click below to request to join the team."
        )
        , !isRequestSent && (
          React.createElement(PrimaryButton, { onClick: handleRequestJoin,}, 'Request to Join')
        )
        , _optionalChain([error, 'optionalAccess', _8 => _8.message]) && (
          React.createElement('div', { className: "mt-4 text-center font-semibold text-tomato-600"   ,}, error.message)
        )
      )
    )
  )
}

export default RequestToJoinComponent
